import { Typography, Box, Grid2 as Grid } from '@mui/material';
import { FC } from 'react';

import { TextInput } from '@carcareers/components';

export const BasicInformationStep: FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
        Your Details
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput required label="First Name" name="user.firstName" autoComplete="given-name" fullWidth />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput required label="Last Name" name="user.lastName" autoComplete="family-name" fullWidth />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextInput required label="Email" name="user.email" type="email" autoComplete="email" fullWidth />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasicInformationStep;
